<span [ngClass]="classMap">
  <input type="checkbox" class="tam-checkbox-input" [(ngModel)]="value" (blur)="onBlur()">
  <span class="tam-checkbox-inner"></span>
</span>
<span #contentElement class="tam-checkbox-content" [ngClass]="contentClassMap" [style.display]="isContentEmpty() ? 'none' : ''"><ng-content></ng-content></span>